/**
 * @flow
 */

import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { withTenant } from '../../context/tenantConfig'

const Text = styled.h1`
  font-family: NexaBold;
  font-size: ${props => (props.big ? 4 : 2.5)}em;
  margin: 0;
`

const StyledLink = styled(Link)`
  display: flex;
  justify-content: center;
`

type Props = {
  big?: boolean,
  style?: any,
  tenant: any
}

function Logo({ big, style, tenant }: Props) {

  return (
    <Text big={big}>
      <StyledLink to="/">
        <img src={tenant ? tenant.config.branding.logo : 'https://hiringgo.com/static/images/newLogo.svg'} alt="Logo" style={{ width: '150px', marginRight: '10px', ...style }} />
      </StyledLink>
    </Text>
  )
}

export default withTenant(Logo)
